import { Controller } from '@hotwired/stimulus'

const ACTIVE_CLASSES = ['text-primary', 'border-primary', 'font-semibold']
const INACTIVE_CLASSES = ['text-base-content/60', 'border-transparent']

// Live, client-side filtering of the external-application rows by name
// (search box) and by environment (tab strip). No round-trip: rows carry a
// `data-name` and `data-env` and are shown/hidden in place.
export default class extends Controller {
  static targets = ['input', 'tab', 'row', 'empty']
  static values = { env: { type: String, default: 'all' } }

  connect() {
    this.update()
  }

  search() {
    this.update()
  }

  selectEnv(event) {
    event.preventDefault()
    this.envValue = event.currentTarget.dataset.listFilterEnvParam || 'all'
  }

  envValueChanged() {
    this.update()
  }

  update() {
    const query = this.query()
    let visibleCount = 0

    this.rowTargets.forEach((row) => {
      const matchesName = row.dataset.name?.includes(query)
      const matchesEnv =
        this.envValue === 'all' || row.dataset.env === this.envValue
      const visible = matchesName && matchesEnv

      row.classList.toggle('hidden', !visible)
      if (visible) visibleCount += 1
    })

    this.updateTabs()
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle('hidden', visibleCount > 0)
    }
  }

  updateTabs() {
    this.tabTargets.forEach((tab) => {
      const isActive = (tab.dataset.listFilterEnvParam || 'all') === this.envValue
      ACTIVE_CLASSES.forEach((cls) => tab.classList.toggle(cls, isActive))
      INACTIVE_CLASSES.forEach((cls) => tab.classList.toggle(cls, !isActive))
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })
  }

  query() {
    if (!this.hasInputTarget) return ''

    return this.inputTarget.value.trim().toLowerCase()
  }
}
